
import * as React from 'react';
import { sfNames, sfParameters } from 'app/components/access-panel/sf-names';
import { UserOccurencePanel } from 'app/components/access-panel/user-occurence/user-occurence-panel';
import { PanelsProps } from 'app/components/access-panel/types';
import { AdminPaperTopPanel } from 'app/area/administration/edit/components';

export const UserOccurence = (props: PanelsProps) => {

  const { readOnly, unSelectAllValues, data, clearValueInStore, formValues, formComponent, translation, validation, personOptionsCodes,
    roleSelected, roleBasedData, fetchingRoleBasedData, accessData, updateAccessData, clearValidation } = props;

  return <AdminPaperTopPanel title={translation.user_occurrence_in_preson_field_lists}>
    <UserOccurencePanel
      readOnly={readOnly}
      unSelectAllValues={unSelectAllValues}
      translation={translation}

      roleSelected={roleSelected}
      roleValue={roleBasedData?.personExcluded}
      accessData={accessData?.personExcluded}
      updateAccessData={updateAccessData}
      fetchingRoleValue={fetchingRoleBasedData}

      formName={sfNames.personExcluded}
      formComponent={formComponent}
      formValues={formValues}
      valueName={sfParameters.domainNode}

      initialValue={data?.personExcluded}
      personOptionsCodes={personOptionsCodes}

      validation={validation}
      clearValueInStore={clearValueInStore}
      clearValidation={clearValidation}
    />
  </AdminPaperTopPanel>;
};
